import { getCurrencyLabel } from "../../services/currency";

export default function SimplifiedControls({
  bankroll,
  onBaseChange,
  platformOptions,
  platformPickerOpen,
  selectedPlatformNames,
  setPlatformPickerOpen,
  togglePlatform,
}) {
  return (
    <div className="simple-grid">
      <div className="simple-card">
        <label className="field-label" htmlFor="banca-base">
          Banca Base ({getCurrencyLabel(bankroll.baseCurrency)})
        </label>
        <input
          id="banca-base"
          className="input-field"
          type="number"
          min="0"
          placeholder="Valor de referencia"
          value={bankroll.base}
          onChange={(event) => onBaseChange(event.target.value)}
        />
        <div className="simple-card__hint">Referencia para calcular o lucro.</div>
      </div>

      <div className="simple-card">
        <div className="simple-card__header">
          <div>
            <div className="field-label">Plataformas</div>
            <div className="simple-card__hint_add">
              Selecione onde sua banca esta distribuida.
            </div>
          </div>
          <button
            className="platform-add-button"
            type="button"
            onClick={() => setPlatformPickerOpen((open) => !open)}
            aria-label="Selecionar plataformas"
            title="Selecionar plataformas"
          >
            +
          </button>
        </div>

        {platformPickerOpen && (
          <div className="platform-picker motion-expand-panel">
            {platformOptions.map((platform, index) => (
              <label
                key={platform}
                className={`platform-option motion-list-row motion-list-row--${Math.min(index, 8)}`}
              >
                <input
                  type="checkbox"
                  checked={selectedPlatformNames.has(platform)}
                  onChange={() => togglePlatform(platform)}
                />
                {platform}
              </label>
            ))}
            <button
              className="platform-picker__done"
              type="button"
              onClick={() => setPlatformPickerOpen(false)}
            >
              Pronto
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
